import { render, staticRenderFns } from "./activar_desactivar_tipo_reportes.vue?vue&type=template&id=051507a5"
import script from "./activar_desactivar_tipo_reportes.vue?vue&type=script&lang=js"
export * from "./activar_desactivar_tipo_reportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports